import numbro from 'numbro'

const filterMap = {
  creatorSize: {
    label: 'Creator size',
    isLocked: true,
  },
  creatorNiche: {
    label: 'Niche',
    isLocked: true,
  },
  creatorGender: {
    label: 'Creator gender',
    isLocked: true,
  },
  creatorAge: {
    label: 'Creator age',
    isLocked: true,
  },
  creatorLocation: {
    label: 'Creator location',
    isLocked: true,
  },
  audienceAge: {
    label: 'Aud. age',
    isLocked: false,
  },
  audienceGender: {
    label: 'Aud. gender',
    isLocked: false,
    values: {
      F: 'Female',
      M: 'Male',
      U: 'Other',
    },
  },
  audienceLocation: {
    label: 'Aud. location',
    isLocked: false,
  },
  avgLikePosts: {
    label: 'Avg. like/post',
    isLocked: false,
  },
  avgCommentsPost: {
    label: 'Avg. comment/post',
    isLocked: false,
  },
  avgERPosts: {
    label: 'Avg. ER/post',
    isLocked: false,
  },
  avgReachPost: {
    label: 'Avg. reach/post',
    isLocked: false,
  },
  preferences: {
    label: 'Preferences',
    isLocked: false,
  },
  tags: {
    label: 'Tags',
    isLocked: true,
  },
}

const filterMapping = (filters = {}) => {
  const tags = {}
  Object.keys(filters).forEach((key) => {
    switch (key) {
      case 'creatorSize': {
        const sizeArr = Array.isArray(filters[key]) ? filters[key] : [filters[key]]
        if (sizeArr.length > 0) {
          const value = sizeArr.map((item) => item.name || `${numbro(item.range[0]).format({ average: true })}${item.range[1] ? '-' + numbro(item.range[1]).format({ average: true }) : '+'}`).join(', ')
          tags[key] = { ...filterMap[key], value }
        }
        break
      }
      case 'avgLikePosts':
      case 'avgCommentsPost':
      case 'avgReachPost':
        if (filters[key].range) {
          tags[key] = {
            ...filterMap[key],
            value: `${numbro(filters[key].range[0]).format({ average: true })}${
              filters[key].range[1] ? ' - ' + numbro(filters[key].range[1]).format({ average: true }) : '+'
            }`,
          }
        }
        break
      case 'creatorNiche': {
        const niches = Array.isArray(filters[key]) ? filters[key] : [filters[key]]
        if (niches.length > 0) {
          tags[key] = { ...filterMap[key], value: niches.map((n) => n.label).filter(Boolean).join(', ') }
        }
        break
      }
      case 'creatorGender': {
        const genderLabels = {
          0: 'Female',
          1: 'Male',
          2: 'Other',
        }
        const genderValues = Array.isArray(filters[key]) ? filters[key] : [filters[key]]
        tags[key] = { ...filterMap[key], value: genderValues.map((v) => genderLabels[v]).filter(Boolean).join(', ') }
        break
      }
      case 'avgERPosts':
        tags[key] = { ...filterMap[key], value: filters[key].size }
        break
      case 'audienceLocation':
        tags[key] = { ...filterMap[key], value: `${filters[key].label}, >${filters[key].percent}%` }
        break
      case 'creatorAge':
        tags[key] = { ...filterMap[key], value: `${filters[key][0]}-${filters[key][1]}` }
        break
      case 'creatorLocation': {
        const locArr = Array.isArray(filters[key]) ? filters[key] : [filters[key]]
        const locNames = locArr.map((l) => l.name).filter(Boolean)
        if (locNames.length > 0) {
          tags[key] = { ...filterMap[key], value: locNames.join(', ') }
        }
        break
      }
      case 'audienceAge':
      case 'tags':
        tags[key] = { ...filterMap[key], value: `${filters[key].map((item) => item.label).join(',')}` }
        break
      case 'audienceGender':
        tags[key] = { ...filterMap[key], value: `${filterMap[key].values[filters[key]]}` }
        break
      case 'preferences':
        tags[key] = { ...filterMap[key], value: `${filters[key].map((item) => item.name).join(',')}` }
        break
    }
  })

  return tags

  // return Object.fromEntries(Object.entries(filterMap).filter(([key, value]) => Object.prototype.hasOwnProperty.call(value, 'value')))
}

export default filterMapping
